export class RegistroFinanceiro {
  id: number;
  saldoAtual: number;
  data: Date;
  statusRegistro: number;
  qtdeMassas: number;
  saldoAnterior: number;
}
